module.exports = __webpack_public_path__ + "static/media/Weatherapp-pic-R.2d116533.PNG";